import { Tooltip, useRevalidateAll } from "@/index.js";
import { memo } from "react";

const RevalidateAll = () => {
  const { isRevalidating, canRevalidate, confirmAndRevalidate } =
    useRevalidateAll();

  return (
    <>
      {canRevalidate && (
        <button
          type="button"
          disabled={isRevalidating}
          onClick={confirmAndRevalidate}
          data-tooltip-placement="bottom"
          data-tooltip-target="revalidateCache"
          aria-label="تحديث كاش المنصة"
          className="group relative flex h-10 w-10 items-center justify-center rounded-full bg-white dark:bg-gray-900 text-gray-500 dark:text-gray-300 ring-1 ring-gray-200 dark:ring-gray-700 transition-all duration-200 hover:bg-purple-50 hover:text-purple-900 hover:ring-purple-200 dark:hover:bg-gray-900/50 dark:hover:text-purple-300 dark:hover:ring-purple-700/40 active:scale-95 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <svg
            fill="none"
            strokeWidth={1.8}
            viewBox="0 0 24 24"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 transition-transform ${
              isRevalidating
                ? "animate-spin"
                : "duration-500 group-hover:rotate-180"
            }`}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.992 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182M20.015 4.356v4.992"
            />
          </svg>
        </button>
      )}
      <Tooltip
        id="revalidateCache"
        title="تحديث كاش المنصة"
        className="dark:bg-gray-700"
      />
    </>
  );
};

export default memo(RevalidateAll);
